import React from 'react';
import { PrimaryButton, IButtonProps } from '@fluentui/react';
import { useStyles } from './index.styles';

export const SuccessButton: React.FC<IButtonProps> = (props) => {
  const styles = useStyles();
  return <PrimaryButton {...props} className={styles.root} />;
};
